import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { testimonials } from '../../data/ultimateData';

const UltimateTestimonials = () => {
 const scrollToForm = () => {
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="testimonials-section" id="testimonials-section" style={{ background: 'linear-gradient(180deg, #0B0B0E 0%, #101014 50%, #0B0B0E 100%)' }}>
 
 {/* Background Effects - Purple */}
 <div className="absolute inset-0">
 <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-[#d4a84b]/8 rounded-full blur-3xl" />
 <div className="absolute bottom-1/3 right-1/4 w-72 h-72 bg-[#d4a84b]/8 rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-12">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 भक्तों के अनुभव
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 हजारों भक्तों की सच्ची कहानियां
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-2xl mx-auto">
 जिनकी जिंदगी <span className="text-[#E2C170] font-bold">माता मलीहा</span> के आशीर्वाद से बदल गई
 </p>
 </div>

 {/* Testimonials Carousel */}
 <Swiper
 modules={[Pagination, Autoplay]}
 spaceBetween={24}
 slidesPerView={1}
 pagination={{ clickable: true, bulletClass: 'swiper-pagination-bullet !bg-red-700/50 !w-3 !h-3', bulletActiveClass: '!bg-[#d4a84b] !scale-125' }}
 autoplay={{ delay: 4000, disableOnInteraction: false }}
 breakpoints={{
 640: { slidesPerView: 2 },
 1024: { slidesPerView: 3 },
 }}
 className="pb-12"
 >
 {testimonials.map((t, index) => (
 <SwiperSlide key={index}>
 <div className="h-full p-6 rounded-2xl bg-gradient-to-br from-[#17171C] to-[#101014] border border-[#d4a84b]/20 hover:border-[#d4a84b]/30 transition-all">
 {/* Quote */}
 <div className="text-4xl text-[#C9A23A]/50 mb-2">"</div>
 
 {/* Content */}
 <p className="text-[#E8E2D6] text-sm mb-4 leading-relaxed">{t.text || `${t.problem}। माता जी की साधना के बाद — ${t.result || 'सब ठीक हो गया'}`}</p>
 
 {/* Rating */}
 <div className="flex gap-1 mb-4">
 {[...Array(5)].map((_, i) => (
 <span key={i} className="text-[#F3EDE2]">★</span>
 ))}
 </div>
 
 {/* Author */}
 <div className="flex items-center gap-3">
 <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#5B1818] to-[#7a2929] border border-[#C9A23A]/50 flex items-center justify-center text-[#E2C170] font-bold text-lg">
 {t.name.charAt(0)}
 </div>
 <div>
 <h4 className="font-bold text-[#D8D2C6]">{t.name}</h4>
 <p className="text-[#D8D2C6]/70 text-xs">{t.location}</p>
 <span className="text-[#D8D2C6]/50 text-xs">{t.profession} • {t.date}</span>
 </div>
 </div>

 {/* Verified Badge */}
 <div className="mt-4 flex items-center gap-2">
 <span className="px-3 py-1 rounded-full text-xs bg-[#250808] border border-[#C9A23A]/40 text-[#E2C170]">
 सत्यापित
 </span>
 </div>
 </div>
 </SwiperSlide>
 ))}
 </Swiper>

 {/* Stats */}
 <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-4xl mx-auto mt-8">
 <div className="text-center p-4 bg-[#0B0B0E] border border-[#d4a84b]/40 rounded-xl border border-[#d4a84b]/60">
 <div className="text-3xl font-black text-[#F3EDE2]">50K+</div>
 <div className="text-[#D8D2C6] text-sm">संतुष्ट भक्त</div>
 </div>
 <div className="text-center p-4 bg-[#0B0B0E] border border-[#d4a84b]/40 rounded-xl border border-[#d4a84b]/60">
 <div className="text-3xl font-black text-[#E2C170]">97%</div>
 <div className="text-[#D8D2C6] text-sm">सफलता दर</div>
 </div>
 <div className="text-center p-4 bg-[#0B0B0E] border border-[#d4a84b]/40 rounded-xl border border-[#d4a84b]/60">
 <div className="text-3xl font-black text-[#F3EDE2]">4.9</div>
 <div className="text-[#D8D2C6] text-sm">औसत रेटिंग</div>
 </div>
 <div className="text-center p-4 bg-[#0B0B0E] border border-[#d4a84b]/40 rounded-xl border border-[#d4a84b]/60">
 <div className="text-3xl font-black text-[#E2C170]">24</div>
 <div className="text-[#D8D2C6] text-sm">राज्यों में सेवा</div>
 </div>
 </div>

 {/* CTA */}
 <div className="text-center mt-10">
 <p className="text-[#D8D2C6] mb-4">आप भी बन सकते हैं अगली सफलता की कहानी!</p>
 <button
 onClick={scrollToForm}
 className="px-10 py-4 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] hover:from-[#f5d77e] hover:to-[#f5d77e] text-black text-lg font-black rounded-full shadow-xl shadow-amber-500/30 hover:scale-105 transition-all"
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 अपनी समस्या बताएं
 </button>
 </div>
 </div>
 </section>
 );
};

export default UltimateTestimonials;
